/**
 * IMPORTS
 */

const dataTitleRemessaProgress = [
  { label: "Campo Chave", accessor: "matricula" },
  { label: "Nome", accessor: "nome" },
  {
    label: "Foto",
    accessor: "url",
    isImage: true,
  },
  { label: "Data Solicitação", accessor: "created_at" },
];

const defaultImageUrl =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ6HYm4lsI8U4a71J7ioS-J-VCe0odRVZARyg&s";

/**
 * EXPORTS
 */
export { dataTitleRemessaProgress, defaultImageUrl };
